module.exports = __webpack_public_path__ + "static/assets/73ea8153cb3f480fbc17cb3af92c1254.gif";